import React, { useState, useTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import SwiperComponent from '../../common/swipers';
import { consoleLog, GetCacheKey } from '../../../services/common/utils';
import Loadingcomponent from '../../loader/loadingcomponent';
import ErrorMessage from '../../messaging/errormessage';
import BottomModalRedeemUsing from '../../common/bottom-modal-nojoom-redeem';
import GiftAnotherNumberModal from '../../common/gift-another-number-modal';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getformatedMsisdn } from '../../../services/common/CommonUtils';
import { MAKE_NOJOOM_HOT_DELAS_EXCLUSIVE } from '../../../services/common/Constants';
import ExclusiveModal from '../../common/exclusive-modal';
import useAppExclusive from '../../../hooks/useAppExclusive';
import AccordianOffer from '../../loader/skeletons/common/accordian-offer';
const AccordionContent = ({ item, type, redirectTo, section, isNojoomPageMaster }) => {

  const navigate = useNavigate();
  const [show, setshow] = useState(false)
  const {show:showexclusive, toggleModal:togglexclusive} = useAppExclusive();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => {
    setshow(!show)
  }
  const name = "ViewAll"
  const toggle = () => {
    setShowModal(!showModal)
  }
  const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
  const selectedMsisdn = useSelector(
    (state) => state.userdata.value.selectedmsisdn
  );
  const {
    userdata: { cvmRecommendationsData },
  } = useSelector((state) => state);
  const customerprofile = useSelector(
    (state) => state?.userdata?.value?.customerprofile
  );
  let msisdn = getformatedMsisdn(customerprofile?.Msisdn);

  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(
    [GetCacheKey(item.uniqueid), item.method, JSON.parse(item.sourceid), {}],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
      enabled: (cvmRecommendationsData && type === 13) ? false : true
    }
  );
  const userDetailsApi = useQuery(
    [
      GetCacheKey("GET_USER_DETAILS"),
      "customerprofile/get",
      { source: "homepage", sec: "splash" },
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
    }
  );

  if ((isLoading || isFetching) && isNojoomPageMaster) {
    return <div className="accordion_collapse_in"><AccordianOffer hideDesc={(section === 'partners' || section === 'services') ? true : false} /></div>
  }else if(isLoading || isFetching){
    return <Loadingcomponent message={'Loading'} />;
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={t("Invalid")} />;
  }

  const handleViewAll = () => {
    consoleLog("section:"+section+",redirectTo:"+redirectTo+"")
    if(section == "hot-deals" && MAKE_NOJOOM_HOT_DELAS_EXCLUSIVE){
      togglexclusive();
      return;
   }
    else if (section === "services") {
      toggleModal();
    } else {
      if (redirectTo) {
      const isHttp = redirectTo?.includes('http');
        if(isHttp){
          window.open(redirectTo, '_blank');
        }else{
          navigate(redirectTo);
        }
      } else {
        return;
      }
    }
  };

  let requiredData = {};
  if(cvmRecommendationsData && type === 13){
    try{
      if(cvmRecommendationsData?.status == "0")
         requiredData.response = cvmRecommendationsData?.response?.filter(item => item.msisdn === msisdn)[0];
      
        }catch{}
  }else{
    requiredData = data;
  }

  return (
    <div className="accordion_collapse_in">
      <SwiperComponent type={type} data={requiredData} psmItem={item} section={section}></SwiperComponent>
      {/* {console.log(item?.metadata?.more_title, "metadata")} */}
      {item?.metadata?.show_viewall === "true" && item?.metadata?.more_title != undefined && (
        <button
          className="custom_btn custom_btn_primary_outline btn_block"
          onClick={handleViewAll}
        >
          {item?.metadata?.more_title}
        </button>
      )}
      <BottomModalRedeemUsing toggleModal={toggleModal}category={data?.category_en + "|" + data?.category_ar} name={name} toggle={toggle} show={show} data={userDetailsApi?.data?.data?.response?.Msisdn} />
      <GiftAnotherNumberModal toggleModal={toggle} show={showModal} name={name} data={userdata?.msisdn} category={data?.category_en + "|" + data?.category_ar} />
      <ExclusiveModal show={showexclusive} toggleModal={togglexclusive} deeplinktext='nojoom' />
    </div>


  );
};

export default AccordionContent;
